import constants from '@/constants';
import { isDebugOn } from '@/logger';

const MODAL_OPEN_CLASS = 'modal-open';


export default {
  props: {
    autoClose: {
      type: Boolean,
      required: false,
      default: false,
    },
    closeTimeout: {
      type: Number,
      required: false,
      default: constants.DEFAULT_SMALL_POPUP_TIMEOUT,
    },
    closeButton: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      required: false,
      default: 'top',
    },
    padding: {
      type: Boolean,
      default: true,
    },
    overlay: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    classModifier() {
      return {
        [`modal-small--${this.type}`]: this.type,
        'modal-small--no-padding': !this.padding,
      };
    },
  },
  mounted() {
    if (this.autoClose && !isDebugOn()) {
      setTimeout(() => this.close(), this.closeTimeout);
    }
  },
  methods: {
    close() {
      this.$emit('modalClose');
    },
  },
  created() {
    document.documentElement.classList.add(MODAL_OPEN_CLASS);
    document.body.classList.add(MODAL_OPEN_CLASS);
  },
  beforeDestroy() {
    document.documentElement.classList.remove(MODAL_OPEN_CLASS);
    document.body.classList.remove(MODAL_OPEN_CLASS);
  },
};



// WEBPACK FOOTER //
// ./src/components/generics/modal/small/small.js